<template>
  <div class="progress-bar">
    <div class="progress-bar__content">
      <icon-delivery />

      <p
        class="progress-bar__text text-body-2xs-bold"
        v-text="progressBarText"
      />
    </div>

    <div class="progress-bar__bar">
      <span
        class="progress-bar__bar--filled"
        :style="{ width: `${ progressBarValue }%` }"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Progress Bar (progress-bar)
 * -----------------------------------------------------------------------------
 * Progress bar that can show completion rate up to 100%.
 *
 */
import { mapState } from 'vuex'

import IconDelivery from '~icons/misc/delivery.svg'

export default {
  name: 'ProgressBar',

  components: {
    IconDelivery,
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      cart: (state) => state.cart.response,
    }),

    /**
     * Is free shipping threshold met.
     * @returns {boolean}
     */
    cartThresholdMet() {
      return this.cart?.total_price >= this.threshold
    },

    /**
     * Gets the remaining number for the free shipping threshold.
     * @returns {number}
     */
    freeDeliveryRemainingValue() {
      return this.threshold - this.cart?.total_price
    },

    /**
     * Gets the percentage value to meet free shipping threshold.
     * @returns {number}
     */
    progressBarValue() {
      if (this.cartThresholdMet) {
        return 100
      }

      return (this.cart?.total_price / this.threshold) * 100
    },

    /**
     * Decide which text will be shown on free shipping progress bar.
     * @returns {string}
     */
    progressBarText() {
      return this.cartThresholdMet
        ? this.$string('cart.free_delivery')
        : this.$string('cart.spend_more', {
          replace: {
            value: this.$formatMoney(this.freeDeliveryRemainingValue),
          },
        })
    },

    /**
     * Compute threshold based on current currency.
     * @returns {Number}
     */
    threshold() {
      return Number(cnvs.freeShipping.threshold)
    },
  },
}
</script>

<style lang="scss">
@import './progress-bar';
</style>
